import type { DeliveryBundle, DeliveryState } from './deliveryState'

export interface FirstFrameResult {
  readonly state: DeliveryState
  /** Manifests of the downloaded bundles to delete, in `onDisk` order. */
  readonly remove: readonly string[]
}

/**
 * Records that the active bundle drew its first map frame: clears the launch
 * marker, confirms the active bundle and returns the downloaded bundles to
 * delete — everything that is not active, last good or pending (bad ones
 * included), spec §3.7. Port of `delivery.FirstFrame`.
 */
export function firstFrame(input: DeliveryState): FirstFrameResult {
  const keep = new Set(
    [input.active, input.lastGood, input.pending]
      .filter((b): b is DeliveryBundle => b !== undefined)
      .map((b) => b.manifest),
  )
  const { marker: _marker, ...rest } = input
  return {
    state: {
      ...rest,
      failures: 0,
      activeConfirmed: true,
      onDisk: input.onDisk.filter((b) => keep.has(b.manifest)),
    },
    remove: input.onDisk.filter((b) => !keep.has(b.manifest)).map((b) => b.manifest),
  }
}
